export default __webpack_public_path__ + "a3dac90bd80541de7ec08ec5fc87f7ee.png";